/**
 * Created by 1 on 2017/8/25.
 */
'use strict';
define([
    './BaseLayer',
    './DistributeLayer',
    './PointLayer',
    './FeaturePointLayer',
    './PointClusterLayer',
    './PointDuplicateLayer',
    './LineLayer',
    './PolygonLayer',
    './StatisticsLayer',
    './PieStatisticsLayer',
    './RingStatisticsLayer',
    './LayerFactory',
    './ElementLayerProxy',
    './ele/PointElement',
    './ele/PolygonElement'
], function(BaseLayer,
    DistributeLayer,
    PointLayer,
    FeaturePointLayer,
    PointClusterLayer,
    PointDuplicateLayer,
    LineLayer,
    PolygonLayer,
    StatisticsLayer,
    PieStatisticsLayer,
    RingStatisticsLayer,
    LayerFactory,
    ElementLayerProxy,
    PointElement,
    PolygonElement) {
    /**
     * @ignore
     * @namespace
     * @memberOf G
     * @description  图层包
     */
    let lys = {
            LayerFactory: LayerFactory,
            BaseLayer: BaseLayer,
            DistributeLayer: DistributeLayer,
            PointLayer: PointLayer,
            LineLayer: LineLayer,
            PolygonLayer: PolygonLayer,
            PointClusterLayer: PointClusterLayer,
            FeaturePointLayer: FeaturePointLayer,
            PointDuplicateLayer: PointDuplicateLayer,
            StatisticsLayer: StatisticsLayer,
            PieStatisticsLayer: PieStatisticsLayer,
            RingStatisticsLayer: RingStatisticsLayer,
            ElementLayerProxy: ElementLayerProxy,
            ele: {
                PointElement: PointElement,
                PolygonElement: PolygonElement
            }

        }
        /**
         * 图层类型
         * @namespace
         * @alias G.lys.TYPES
         */
    lys.TYPES = {
        /**
         *element点图层
         */
        'ELEMENT_POINT_LAYER': PointLayer.type,
        /**
         *feature点图层
         */
        'FEATURE_POINT_LAYER': FeaturePointLayer.type,
        /**
         *像素聚合图层；
         */
        'ELEMENT_POINT_PIXEL_CLUSTER': PointClusterLayer.type,
        /**
         *重复点展示图层；
         */
        'ELEMENT_POINT_DUPLICATE': PointDuplicateLayer.type,
        /**
         * element线图层
         */
        'ELEMENT_POLYLINE_LAYER': LineLayer.type,
        /**
         *element面图层
         */
        'ELEMENT_POLYGON_LAYER': PolygonLayer.type,
        /**
         * 简单饼状统计图层
         */
        'PIE_STATISTICS_LAYER': PieStatisticsLayer.type,
        /**
         * 环状占比统计图层
         */
        'RING_STATISTICS_LAYER': RingStatisticsLayer.type,
        /**
         * 底图图层类型标识
         */
        'BASE_LAYER_TAG': '_base_layer_tag'
    };

    return lys;

});